import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMethods } from '@shared/hooks/methods'
import {
    useQueryClient,
    useMutation
} from '@tanstack/react-query'

import axios from '@shared/utils/axios'

export default function Logout() {
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const { showMessage } = useMethods()

    const { mutate } = useMutation({
        mutationFn: async () => {
            const response = await axios.post('auth/logout')
            return response.data
        },

        onMutate: () => {
            showMessage({
                text: 'جارٍ تسجيل الخروج...',
                loading: true
            })
        },
        onSuccess: () => {
            queryClient.setQueryData(['user'], null)
            queryClient.removeQueries({
                predicate: q => q.queryKey[0] !== 'user'
            })
            showMessage({ text: 'قد نجح تسجيل خروجك.' })
            navigate('/auth/login', { replace: true })
        },
        onError: (e) => {
            showMessage({ text: 'فشلت محاولة الخروج.' })
        },
        onSettled: () => {
            showMessage(null)
        }
    })

    useEffect(() => {
        mutate()
    }, [])

    return (<p>جارٍ تسجيل الخروج.</p>)
}